import React from 'react'
import { useTranslation } from 'react-i18next'

import { nonGsmChars, smsInfo } from 'helpers/sms'

/**
 * Счётчик под полем текста SMS: сколько символов набрано, сколько ещё влезет в текущую SMS
 * и сколько SMS (сегментов) уйдёт на одного получателя.
 *
 * Латиница — 160 символов в одной SMS (в длинной по 153 на часть), но одна кириллическая
 * буква или типографский символ переводит ВСЁ сообщение в режим 70 (по 67 на часть).
 * Считает зеркало бэкенда (helpers/sms.js ↔ App\Helper\SmsSegments) — цифры совпадают
 * с тем, что спишется у провайдера Mison SMS.
 */
function SmsCounter({ text }) {
	const { t } = useTranslation()

	const value = String(text || '')
	const info = smsInfo(value)
	const isUnicode = info.encoding === 'UCS-2'
	const culprits = isUnicode ? nonGsmChars(value) : []
	const isLong = info.segments > 1

	return (
		<div className="mt-1" style={{ fontSize: '12px' }}>
			<div className="d-flex flex-wrap gap-3">
				<span>
					<span className={`badge ${isUnicode ? 'bg-warning text-dark' : 'bg-success'} me-1`}>
						{isUnicode ? t('sms_encoding_cyrillic') : t('sms_encoding_latin')}
					</span>
					{isLong
						? t('sms_chars_per_part', { chars: info.perSegment })
						: t('sms_chars_per_sms', { chars: info.perSegment })}
				</span>
				<span>{t('sms_chars_typed')}: <b>{info.length}</b></span>
				<span>{t('sms_chars_left')}: <b>{info.remaining}</b></span>
				<span>
					{t('sms_segments')}: <b className={isLong ? 'text-danger' : ''}>{info.segments}</b>
				</span>
			</div>
			{culprits.length > 0 &&
				<div className="text-danger">
					{t('sms_unicode_culprits', { chars: culprits.join(' ') })}
				</div>
			}
			{!isUnicode && value.length > 0 &&
				<div className="text-muted">{t('sms_cyrillic_warning')}</div>
			}
			{value.includes(':username') &&
				<div className="text-muted">{t('sms_username_length_hint')}</div>
			}
		</div>
	)
}

export default SmsCounter
